var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"content"}},[_c('center',[_c('br'),_c('h1',[_vm._v("404")]),_c('h1',[_vm._v("找不到網站 | Not Found")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }